import { useEffect, useRef, MutableRefObject } from 'react';

type OnFilterChange = () => void;

/**
 * Эффект фильтра по объекту в профиле: при смене selectedSiteId
 * вызывает перезагрузку постов (сброс пагинации и повторный запрос).
 * Первый запуск при монтировании пропускается (начальная загрузка идёт из эффекта userId).
 */
export function useProfileSiteFilter(
  profileUserId: number | undefined,
  hasLoadedOnceRef: MutableRefObject<boolean>,
  selectedSiteId: number | null,
  onFilterChange: OnFilterChange
) {
  const isFirstRunRef = useRef(true);

  useEffect(() => {
    if (isFirstRunRef.current) {
      isFirstRunRef.current = false;
      return;
    }
    if (hasLoadedOnceRef.current && profileUserId) {
      onFilterChange();
    }
  }, [selectedSiteId, profileUserId, hasLoadedOnceRef, onFilterChange]);
}
